import React from "react";
import { motion } from "framer-motion";

const stats = [
  { value: "Est. 2005", label: "Founded" },
  { value: "5,000+", label: "Careers Built" },
  { value: "99%", label: "Visa Success Rate" },
  { value: "100,000+", label: "Counselling Hours" },
  { value: "1-on-1", label: "Personalised Counselling" },
  { value: "Founder-led", label: "Expert Guidance, Always" },
];

export default function TrustBar() {
  return (
    <section
      id="trust-bar"
      data-testid="trust-bar"
      style={{ backgroundColor: "#F8FAFC", borderTop: "1px solid #E2E8F0", borderBottom: "1px solid #E2E8F0", padding: "40px 0" }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 24px" }}>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          style={{ display: "grid", gap: "0" }}
          className="mw-grid-3"
        >
          {stats.map((stat, i) => (
            <motion.div
              key={stat.value}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07, duration: 0.4 }}
              data-testid={`trust-stat-${i}`}
              style={{
                textAlign: "center",
                padding: "16px 12px",
                borderRight: i < stats.length - 1 ? "1px solid #E2E8F0" : "none",
              }}
            >
              <div style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#2B2F9E",
                fontFamily: "'Playfair Display', serif",
                lineHeight: "1.2",
              }}>
                {stat.value}
              </div>
              <div style={{
                fontSize: "12px",
                color: "#64748B",
                fontFamily: "'DM Sans', sans-serif",
                marginTop: "4px",
                fontWeight: "500",
              }}>
                {stat.label}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
